export class EnvironmentConfig {
  endPoint: string;
  surveyEndPoint: string;
  turnstileKey: string;
}
